import PageTitle from './PageTitle';

/**
 * PageHeaderV2 — legacy wrapper kept for pages that already import it.
 * Now delegates to the shared PageTitle component so every page shares the
 * same visual language (Outfit light + cyan-to-blue accent).
 *
 * If a `highlight` prop is passed, that word is rendered as the gradient
 * accent. Otherwise the last word of `title` is auto-detected and used as
 * the highlight so old callers get a modern look for free.
 */
const PageHeaderV2 = ({ title = '', subtitle, highlight }) => {
  let mainTitle = title;
  let mainHighlight = highlight;
  if (!mainHighlight && title) {
    const parts = title.trim().split(/\s+/);
    if (parts.length > 1) {
      mainHighlight = parts.pop();
      mainTitle = parts.join(' ');
    }
  }
  return (
    <div className="w-full py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <PageTitle
          title={mainTitle}
          highlight={mainHighlight}
          subtitle={subtitle}
          align="center"
        />
      </div>
    </div>
  );
};

export default PageHeaderV2;
